import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  days,
  everyTime,
  generateDays,
  generateHours,
  koreanMap,
  noneTime,
  parse,
  ScheduleCell,
} from 'components/TimeTable'

const TimeTableReadOnly = ({ weeklySchedule = everyTime, size, error }) => {
  const wrapRef = useRef()
  const checkedList = parse(weeklySchedule)

  const [activeList, setActiveList] = useState([])
  const handleDaysActive = day => {
    setActiveList(generateHours(day))
  }
  const handleHoursActive = hour => {
    setActiveList(generateDays(hour))
  }
  const clearActive = () => {
    setActiveList([])
  }

  useEffect(() => {
    const emptyValue = noneTime.split('')
    checkedList.forEach(item => {
      const index =
        days.indexOf(item.day) * 24 + days.indexOf(item.day) + item.hour
      emptyValue[index] = '1'
    })
  }, [checkedList, weeklySchedule])

  return (
    <div ref={wrapRef} className={classNames('sch_wrap', { in_error: error })}>
      <table className="tbl_sch">
        <caption className="hide_caption">요일시간 상세설정 테이블</caption>
        <colgroup>
          <col />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
          <col style={{ width: size === 'medium' ? 71 : 31 }} />
        </colgroup>
        <thead>
          <tr>
            <th className="th_tit">
              <div className="tit_wrap">
                <span className="tit_week">요일</span>
                <span className="tit_week week_time">시간</span>
              </div>
            </th>
            {days.map(day => (
              <th
                key={`${day}CheckHeader`}
                scope="col"
                onMouseEnter={() => handleDaysActive(day)}
                onMouseLeave={clearActive}>
                <div className="check_sch">
                  <input
                    type="checkbox"
                    id={`${day}Check`}
                    className="inp_check"
                    value={day}
                    checked={
                      checkedList.filter(item => item.day === day).length === 24
                    }
                    readOnly
                  />
                  <label htmlFor={`${day}Check`} className="lab_option">
                    <span className="txt_week">{koreanMap[day]}</span>
                  </label>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(24).keys()].map(hour => (
            <tr key={`timeCheck${hour}Header`}>
              <th
                scope="row"
                onMouseEnter={() => handleHoursActive(hour)}
                onMouseLeave={clearActive}>
                <div className="check_sch">
                  <input
                    type="checkbox"
                    id={`timeCheck${hour}`}
                    className="inp_check"
                    value={hour}
                    checked={
                      checkedList.filter(item => item.hour === hour).length ===
                      7
                    }
                    readOnly
                  />
                  <label htmlFor={`timeCheck${hour}`} className="lab_option">
                    {String(hour).padStart(2, '0')} {size === 'medium' && '시'}
                  </label>
                </div>
              </th>
              {days.map(day => (
                <ScheduleCell
                  key={`${day}${hour}`}
                  day={day}
                  hour={hour}
                  checkedList={checkedList}
                  activeList={activeList}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

TimeTableReadOnly.propTypes = {
  weeklySchedule: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  error: PropTypes.any,
}

export default TimeTableReadOnly
